export const containsLowerCase = (text: string) => /(?=.*[a-z])/.test(text)
export const containsUpperCase = (text: string) => /(?=.*[A-Z])/.test(text)
export const containsUpperAndLower = (text: string) =>
  containsLowerCase(text) && containsUpperCase(text)
export const containsNumber = (text: string) => /(?=.*\d)/.test(text)
export const containsSpecialCharacter = (text: string) => /[-+_!@#$%^&*.,?]/.test(text)
export const isAtLeastLength = (text: string, length: number) => text.length >= length
export type PasswordConditions = {
  upperAndLower: boolean
  number: boolean
  specialChar: boolean
  length16: boolean
  length8: boolean
}

export const evaluatePasswordConditions = (password: string): PasswordConditions => ({
  upperAndLower: containsLowerCase(password) && containsUpperCase(password),
  number: containsNumber(password),
  specialChar: containsSpecialCharacter(password),
  length8: isAtLeastLength(password, 8),
  length16: isAtLeastLength(password, 16),
})

export const isValidShortPass = (condition: PasswordConditions): boolean =>
  condition.upperAndLower && condition.number && condition.length8 && condition.specialChar

export const isValidLongPass = (condition: PasswordConditions): boolean => condition.length16

export const deriveColor = (condition: boolean, newPassword: string) => {
  if (condition) return 'text-green-700 bg-green-200'
  if (newPassword) return 'text-red-700 bg-red-200'
  return 'text-yellow-700 bg-yellow-200'
}

export const deriveColorConditions = (conditions: PasswordConditions, newPassword: string) => {
  const shortPass = isValidShortPass(conditions)
  const longPass = isValidLongPass(conditions)

  return {
    upperAndLower:
      longPass && !containsUpperAndLower(newPassword)
        ? 'text-yellow-700 bg-yellow-200'
        : deriveColor(conditions.upperAndLower, newPassword),
    number:
      longPass && !containsNumber(newPassword)
        ? 'text-yellow-700 bg-yellow-200'
        : deriveColor(conditions.number, newPassword),
    specialChar:
      longPass && !containsSpecialCharacter(newPassword)
        ? 'text-yellow-700 bg-yellow-200'
        : deriveColor(conditions.specialChar, newPassword),
    length8: deriveColor(conditions.length8, newPassword),
    length16:
      shortPass && !longPass
        ? 'text-yellow-700 bg-yellow-200'
        : deriveColor(conditions.length16, newPassword),
  }
}
